module.exports = __webpack_public_path__ + "img/IMG_1899_L_Wood.19b8d115.jpg";